import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addSort, changeFilter } from '../../features/filterSlice/filterSlice';

const SideBar = () => {
    const { all } = useSelector(state => state.filter)
    const dispatch = useDispatch()
    const handleSortChange = (e) => {
        const value = e.target.value
        dispatch(addSort(value))

    }
    return (
        <aside>
            <div className="sidebar-items">
                <div className="sidebar-content">
                    <h4>Sort</h4>
                    <select onChange={handleSortChange} name="sort" id="lws-sort" className="w-full max-w-[150px] border-2 rounded-md text-gray-500">
                        <option value="">Default</option>
                        <option value="newest">Newest</option>
                        <option value="most_liked">Most Liked</option>
                    </select>
                </div>
                <div className="sidebar-content">
                    <h4>Filter</h4>
                    <div className="radio-group">
                        {/* <!-- handle filter on button click --> */}
                        <div>
                            <input onClick={() => {
                                dispatch(changeFilter(true))
                            }} type="radio" name="filter" defaultChecked id="lws-all" value={all} className="radio" />
                            <label for="lws-all">All</label>
                        </div>
                        <div>
                            <input onClick={() => {
                                dispatch(changeFilter(false))
                            }} type="radio" name="filter" value={all} id="lws-saved" className="radio" />
                            <label for="lws-saved">Saved</label>
                        </div>
                    </div>
                </div>
            </div>
        </aside>
    );
};

export default SideBar;